const localisation = {
    currencySelector: {
        label: "Currency",
    },
    supplierSelector: {
        label: "Supplier",
        placeholder: "Type to search",
        noOptionsLabel: "No Options",
        loadingLabel: "Loading...",
    },
    warehouseSelector: {
        label: "Warehouse",
        placeholder: "Type to search",
        noOptionsLabel: "No Options",
        loadingLabel: "Loading...",
    },
};

export default localisation;
